export const mgPlatformTickIcon = {
  data: `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.83329 1.1665C6.83329 1.1665 3.66663 3.6665 2.83329 6.83317L1.16663 4.49984" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'tick'
}
